import {
  GEARBOX_CONVERTER,
  ENGINES_CONVERTER,
  WHELL_DRIVE,
  FEATURES,
} from 'shared/constants/adverts';
import { getPriceValueBySlug, convertMlToKm } from 'shared/helpers/transportInfo';
// import API from 'shared/constants/api';
import { generateUrl } from 'shared/helpers/urls';
import { numberWithSpaces } from 'shared/helpers/common';
import { getPrice } from 'shared/helpers/advert';
import regexp from 'shared/constants/regexp';
import { getGoogleCaptchaToken } from 'shared/helpers/google';
import { getAnnuityRate, getAnnuityMonthPayment } from './myAutoCalculate';

const isClient = process.env.BROWSER;
const HOST = process.env.HOST || process.env.WEBSITE_HOSTNAME;

/**
 *
 * @param {String} deviceId
 * @returns
 */
export const getCleanDeviceId = deviceId => deviceId.replace(/^"(.*)"$/, '$1');

/**
 *
 * @param {String} path
 * @param {Object} body
 * @param {Function} fetch
 * @param {Object} headers
 * @param {String} action
 * @returns
 */
export const execPostRequest = async (path, body, fetch, headers = {}, action = 'addlead') => {
  let result = null;
  // const headers = { 'Content-Type': 'application/json', addHeaders }; // 'x-access-key': X_ACCESS_KEY_VRF
  try {
    const gtoken = action ? await getGoogleCaptchaToken(action) : '';
    const data = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', headers, gtoken },
      body: JSON.stringify(body),
    };
    console.info('execPostRequest', path);
    const response = await fetch(path, data);
    result = await response.json();
  } catch (e) {
    console.error(e);
  }
  return result;
};

// TODO; MOVE METHODS TO MyCredits !!!

export const getLeasingParms = advert => {
  const { fin_up_verification: finUp } = advert;
  if (finUp && finUp.payload && finUp.payload.monthlyPayment) {
    return finUp.payload;
  }
  return null;
};

function getFeatures(options) {
  if (!Array.isArray(options) || !options.length) return [];
  const features = [];
  for (let i = 0, l = options.length; i < l; i += 1) {
    const { title, parents } = options[i];
    if (FEATURES[title]) {
      features.push(FEATURES[title]);
    } else if (parents[1] && FEATURES[`${parents[1].title}-${title}`]) {
      features.push(FEATURES[`${parents[1].title}-${title}`]);
    }
  }
  return features;
}

export function getCapacity(adv) {
  const cpcty = adv.characteristics.capacity ? adv.characteristics.capacity.number : adv.capacity;
  const capacity = cpcty / 100 > 0.1 ? cpcty : cpcty * 1000;
  return capacity;
}

function getGeo(adv) {
  const obl = adv.location && adv.location.parents && adv.location.parents.pop();
  const geo =
    (obl && `${obl.title}, ${adv.location.title}`) ||
    (adv.location && adv.location.title ? adv.location.title : adv.location);
  return geo;
}

export function getLeasingArgumentsByAdv(adv) {
  const generation = adv.modification.generation && adv.modification.generation.title;
  const geo = getGeo(adv);
  const photos = (adv.photos || []).map(photo => photo.image) || [];
  const name = (adv.author && adv.author.first_name && adv.author.first_name) || '';
  const phones =
    (adv.agency &&
      Array.isArray(adv.agency.phones) &&
      adv.agency.phones.map(phone => phone.number)) ||
    [];

  const params = {
    localId: `${adv.id}`,
    brand: adv.make.slug || adv.make_title,
    model: adv.model.slug || adv.model_title,
    generation,
    year: adv.year,
    engineType: adv.engine && ENGINES_CONVERTER[adv.engine.slug],
    transmission: adv.gearbox && GEARBOX_CONVERTER[adv.gearbox.slug],
    engineVolumeMl: getCapacity(adv),
    mileageKm: convertMlToKm(adv) * 1000,
    description: adv.description,
    features: getFeatures(adv.options),
    geo,
    photos,
    wheelDrive: adv.drive && WHELL_DRIVE[adv.drive.slug],
    contact: {
      name,
      phones,
    },
  };

  const path = generateUrl(adv);
  const host = (isClient && location && location.host) || HOST || 'avtobazar.ua';
  const url = `https://${host}${path}`;
  const options = {
    sum: getPriceValueBySlug(adv.price, 'usd'),
    url,
    currency: 'USD',
  };
  return { params, options };
}

// export const calculateExchange = (prices, value, currency) => {
//   const isUsdCurrent = prices.find(data => data.exchange_rate === 1 && data.currency === 'usd');
//   const isUsdCurrent = prices.find(data => data.exchange_rate === 1 && data.currency === 'eur');

//   const ukExchangeRate = prices.find(
//     exchangeItem =>
//       isUsdCurrent ? exchangeItem.currency === 'uah' : exchangeItem.currency === 'usd',
//   ).exchange_rate;

//   let result = 0;
//   if (currency === 'usd') result = isUsdCurrent ? value / ukExchangeRate : value * ukExchangeRate;
//   else result = isUsdCurrent ? value * ukExchangeRate : value / ukExchangeRate;

//   return parseInt(result, 10);
// };

export const calculateExchange = (prices, value, toCurrency, fromCurrency = 'usd') => {
  const toCurr = prices.find(data => data.currency === toCurrency);
  const fromCurr = prices.find(data => data.currency === fromCurrency);

  if (toCurrency.exchange_rate === 1) {
    return parseInt(toCurr.exchange_rate * value, 10);
  }
  if (fromCurrency.exchange_rate === 1) {
    return parseInt(value / fromCurr.exchange_rate, 10);
  }
  return parseInt(value / fromCurr.exchange_rate * toCurr.exchange_rate, 10);
};

/**
 *
 * @param {Object} advert
 * @param {Number} monthly
 * @param {String} currencySlug
 * @param {String} formated
 * @returns
 */
export const getMonthlyPrice = (advert, monthly, currencySlug = 'uah', formated = true) => {
  if (!advert || !monthly) return 0;
  let prices = [];

  if (Array.isArray(advert.prices)) prices = advert.prices;
  else if (Array.isArray(advert.price)) prices = advert.price;

  const result = calculateExchange(prices, monthly, currencySlug);

  return formated ? numberWithSpaces(result) : result;
};

export const calculateMonthlyPayment = advert => {
  const TERM = 84;
  const PREPAID = 0.3;

  const { year } = advert;

  const price = getPrice(advert.price || advert.prices, ['usd']);
  const sum = price - price * PREPAID;
  const rate = getAnnuityRate(year);
  const monthly = getAnnuityMonthPayment(sum, rate, TERM);
  // console.log(`PRICE: ${price}, SUN: ${sum}, RATE: ${rate}, TERM: ${TERM} RESULT : ${monthly}`);

  return monthly;
};

export const calculateMonthlyPaymentV2 = data => {
  const { year, term, price, prepaid, comission, rate } = data;
  const sum = price - (prepaid - comission);
  const monthly = getAnnuityMonthPayment(sum, rate || getAnnuityRate(year), term || 84);

  return Math.round(monthly);
};

export const isHapaiLeasing = lp => lp && lp.extendedParams && lp.extendedParams.hapai;
export const isAutoMoneyLeasing = lp => false; // lp && lp.isAutoMoneyCalculated;
export const isUlfLeasing = lp => lp && lp.isUlfCalculated;
export const isUlf24Leasing = lp => lp && lp.isUlf24Calculated;

export const getMothlyPaymentFormatted = lp =>
  lp &&
  lp.extendedParams &&
  ((lp.extendedParams.hapai && lp.extendedParams.hapai.monthlyPaymentUAHFormatted) ||
    lp.extendedParams.monthlyPaymentUAHFormatted);

export const userFormValidation = data => {
  let phoneToTest = '';
  const tempPhone = data.phone.replace(/\s/g, '');
  if (tempPhone.charAt(0) !== '+') {
    phoneToTest = `+${tempPhone}`;
  } else {
    phoneToTest = tempPhone;
  }

  if (
    !regexp.phone.test(phoneToTest) ||
    phoneToTest.charAt(4) === '0' ||
    phoneToTest.length !== 13
  ) {
    return 'Некорректный номер мобильного телефона';
  }

  if (!regexp.name.test(data.userName)) {
    return 'Некорректное имя';
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/utils.js